<template>
    <div>
        <b-carousel id="carouselDemo" v-model="slide" :interval="0" controls indicators
                    @sliding-start="$_onSlideStart">
            <b-carousel-slide v-for="(t, index) in getRecords" v-bind:key="t.id">
                <div class="wrapper">
                    <div class="div-left">
                        <div class="div-left-sub">
                            <div class="caption-wrapper d-none d-sm-block">
                                <h5>Case {{ slide + 1 }} – {{ t.alias }}</h5>
                                <p>{{ t.description }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="div-right">
                        <div class="div-right-sub">
                            <iframe ref="iframeWebtheme" title="webthemePreview" class="preview-frame" :src="index == 0 ? t.url : 'about:blank'"></iframe>
                        </div>
                    </div>
                </div>
            </b-carousel-slide>
        </b-carousel>
    </div>
</template>

<script>
    export default {
        props: {
            webthemes: { type: Array, required: true },
            organization: { type: String, required: true },
            group: { type: String, required: false }
        },

        created() {
            document.title = 'NedGlobe Demo';
        },

        computed: {
            getRecords() {
                // Last page is page with link to Portal
                if (this.localWebthemes && this.localWebthemes.length > 0) {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.localWebthemes.push(this.portalpage);
                    this.$_addIndicatorTitles();
                }
                return this.localWebthemes;
            }
        },

        data() {
            const paramGroup = this.group ? `&group=${this.group}` : '';

            return {
                portalpage: {
                    alias: 'Voorbeeld van een geo portaal',
                    description: 'Dit is een voorbeeld van een geo portaal waarin alle webthemakaarten als plaatjes staan. ' +
                        'Er kan gefilterd worden op naam en omschrijving. ' +
                        'Er kan alfabetisch gesorteerd worden of op populariteit.',
                    url: `portal?mode=P&sort=P&organization=${this.organization}${paramGroup}`
                },
                slide: 0,
                localWebthemes: null
            };
        },

        methods: {
            $_onSlideStart(slide) {
                const iframe = this.$refs.iframeWebtheme[slide];
                if (iframe && iframe.src === 'about:blank') {
                    iframe.src = this.localWebthemes[slide].url;
                }
            },

            $_addIndicatorTitles() {
                setTimeout(() => {
                    const indicatorContainer = document.querySelector('.carousel-indicators');
                    if (indicatorContainer) {
                        const indicators = indicatorContainer.getElementsByTagName('li');
                        for (var i = 0; i < indicators.length; ++i) {
                            indicators[i].title = this.localWebthemes[i].alias;
                        }
                    }
                }, 100);
            }
        },
        watch: {
            webthemes: {
                handler: function (newVal) {
                    this.localWebthemes = JSON.parse(JSON.stringify(newVal));
                },
                deep: true,
                immediate: true
            }
        }
    };
</script>

<style>
    .carousel .carousel-indicators li {
        width: .625rem;
        height: .625rem;
        -webkit-border-radius: 50%;
        border-radius: 50%;
        cursor: pointer;
        background-color: #007ac9;
    }

    .carousel-caption {
        position: initial;
        padding: 0px;
        height: 100vh;
    }

    .carousel-control-prev, .carousel-control-next {
        padding: 10px 0px;
        top: initial;
        cursor: pointer;
        opacity: initial;
    }

    .carousel-control-prev {
        padding-left: 37px;
        justify-content: initial;
    }

    .carousel-control-next {
        padding-right: 37px;
        justify-content: flex-end;
    }

    .carousel-control-prev-icon, .carousel-control-next-icon {
        background-color: #007ac9;
        border-radius: 4px;
        padding: 0 15px;
        padding: 20px;
        background-position: center;
        background-size: 13px;
    }

        .carousel-control-prev-icon:hover, .carousel-control-next-icon:hover {
            background-color: #184185;
        }
</style>

<style scoped>
    h5, .h5 {
        font-weight: bold;
    }

    .wrapper {
        height: 100%;
        width: 100%;
        overflow: hidden; /* will contain if #first is longer than #second */
        background-color: #ebebeb;
    }

    .caption-wrapper {
        position: initial;
        color: black;
        height: 100%;
        padding: 20px;
        text-align: left;
        background-color: #fff;
        border: 1px solid #d0cece;
        overflow-y: auto;
    }

    .div-left {
        width: 40%;
        height: 100%;
        padding: 20px 10px 60px 20px;
        float: left; /* add this */
    }

    .div-right {
        width: 60%;
        height: 100%;
        padding: 20px 20px 60px 10px;
        overflow: hidden; /* if you don't want #second to wrap below #first */
    }

    .div-left-sub {
        width: 100%;
        height: 100%;
        padding: 20px;
        background-color: #f9f9f9;
    }

    .div-right-sub {
        height: 100%;
        width: 100%;
        background-color: #f9f9f9;
    }

    .preview-frame {
        width: 100%;
        height: 100%;
        border: 0;
    }
</style>
